import Vue from 'vue'
import { PageHeader, Spin, message } from 'ant-design-vue'

Vue.use(PageHeader)
Vue.use(Spin)
Vue.prototype.$message = message
